import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../components/ui/sheet";
import { HelpSidebar } from "../../ui/molecules/help-sidebar";
import type { HelpArticle } from "../../help-types";
import { useTranslation } from "react-i18next";

export type HelpCenterProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    suggestedHelpArticles?: HelpArticle[];
};

export const HelpCenter = ({
    open,
    onOpenChange,
    suggestedHelpArticles,
}: HelpCenterProps): JSX.Element => {
    const { t } = useTranslation();

    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            {/* Preflight required for portal view to be styled correctly */}
            <SheetContent className="preflight overflow-auto p-0 md:max-w-[700px]">
                <div className="flex h-full max-h-full flex-col">
                    <SheetHeader className="p-6 pb-2">
                        <SheetTitle>{t("component.sidebarNavigation.helpCenter")}</SheetTitle>
                    </SheetHeader>
                    <HelpSidebar withHeader={false} suggestedHelpArticles={suggestedHelpArticles} />
                </div>
            </SheetContent>
        </Sheet>
    );
};
